/**
 * External Packages Configuration
 *
 * Define external npm packages that can be loaded as dependencies by components.
 *
 * Usage in component:
 *   export default class MyComponent {
 *     static dependencies = ['PackageName'];
 *     constructor(element, options, dependencies) { ... }
 *   }
 */
export const EXTERNAL_PACKAGES = {};
